export default __webpack_public_path__ + "static/media/3451ea7b7805663e725b69ec746069d21629978204699.4f914732.webp";